module.exports = __webpack_public_path__ + "static/olaniyan-d98b929ba55d9dc078548c99f5242f10.png";